import {
  SAVE_PROPOSAL,
  SAVE_QUOTATION,
  SAVE_QUOTATION_SUCCESS,
  SAVE_QUOTATION_ERROR,
  SAVE_PROPOSAL_SUCCESS,
  SAVE_PROPOSAL_ERROR,
  UPDATE_QUOTATION,
  SEARCH_CUSTOMER_BY_FISCAL,
  SEARCH_CUSTOMER_BY_VAT,
  CUSTOMER_RECEIVED,
  CUSTOMER_FOUND,
  UPDATE_CUSTOMER_INPUT,
  RESET_CUSTOMER,
  SET_UPDATED,
  SET_CONTRACTUAL_CATEGORY_TYPE,
  FILE_UPLOADED,
} from './constants';

export function saveProposal(params) {
  return {
    type: SAVE_PROPOSAL,
    proposal: params,
  };
}

// export function saveQuotation(params) {
//   return {
//     type: SAVE_QUOTATION,
//     quotation: params,
//   };
// }

export function saveQuotationSuccess(data) {
  return {
    type: SAVE_QUOTATION_SUCCESS,
    data,
  };
}

export function saveQuotationError(errors) {
  return {
    type: SAVE_QUOTATION_ERROR,
    errors,
  };
}

export function saveProposalSuccess(data) {
  return {
    type: SAVE_PROPOSAL_SUCCESS,
    data,
  };
}

export function saveProposalError(errors) {
  return {
    type: SAVE_PROPOSAL_ERROR,
    errors,
  };
}

export function updateQuotation(params) {
  return {
    type: UPDATE_QUOTATION,
    quotation: params,
  };
}

export function setUpdated(value) {
  return {
    type: SET_UPDATED,
    value,
  };
}

export function searchCustomerByFiscal(fiscalCode, contractualCategory = null) {
  return {
    type: SEARCH_CUSTOMER_BY_FISCAL,
    fiscalCode,
    contractualCategory
  };
}

export function searchCustomerByVat(vatNumber, contractualCategory = null) {
  return {
    type: SEARCH_CUSTOMER_BY_VAT,
    vatNumber,
    contractualCategory
  };
}

export function selectContractualCategoryType(contractualCategoryType) {
  return {
    type: SET_CONTRACTUAL_CATEGORY_TYPE,
    contractualCategoryType
  };
}

export function customerLoaded(customer) {
  return {
    type: CUSTOMER_RECEIVED,
    customer,
  };
}

export function customerFound(found) {
  return {
    type: CUSTOMER_FOUND,
    found,
  };
}

export function resetCustomer() {
  return {
    type: RESET_CUSTOMER,
  };
}

export function updateCustomerInput(field, value) {
  return {
    type: UPDATE_CUSTOMER_INPUT,
    field,
    value
  };
}

export function fileUploaded(data) {
  return {
    type: FILE_UPLOADED,
    data
  };
}
